/**
 * Static content for the Physician Order form. Category keys must stay in sync
 * with `ORDER_BLOCK_CATEGORIES` on the backend physician-order module.
 */

export const ORDER_BLOCK_CATEGORIES = [
  {
    value: "eligibility",
    label: "Eligibility",
    placeholder:
      "Document homebound status, skilled need, and other eligibility criteria…",
  },
  {
    value: "diagnosis",
    label: "Diagnosis",
    placeholder: "List primary and secondary diagnoses with ICD codes…",
  },
  {
    value: "medications",
    label: "Medications",
    placeholder: "Medication name, dose, route, frequency, and related orders…",
  },
  {
    value: "dme_supplies",
    label: "DME / Supplies",
    placeholder: "Durable medical equipment and supply orders…",
  },
  {
    value: "safety_measures",
    label: "Safety Measures",
    placeholder: "Fall precautions, infection control, and other safety orders…",
  },
  {
    value: "nutritional_requirements",
    label: "Nutritional Requirements",
    placeholder: "Diet type, restrictions, fluid goals, and nutrition orders…",
  },
  {
    value: "allergies",
    label: "Allergies",
    placeholder: "Known allergies and related clinical precautions…",
  },
  {
    value: "functional_limitations",
    label: "Functional Limitations",
    placeholder: "Mobility, ADLs, cognition, and other functional limits…",
  },
  {
    value: "interventions",
    label: "Interventions",
    placeholder:
      "SN / therapy interventions, assessments, teaching, and monitoring…",
    tags: [
      "Acute Exacerbation",
      "Chronic Management",
      "Post-Surgical",
      "New Diagnosis",
    ],
  },
  {
    value: "advance_directives",
    label: "Advance Directives",
    placeholder: "Code status and advance directive instructions…",
  },
];

export const ORDER_CATEGORY_BY_VALUE = Object.fromEntries(
  ORDER_BLOCK_CATEGORIES.map((c) => [c.value, c]),
);

export const VISIT_FREQUENCY_ROWS = [
  { key: "freqSkilledNursing", label: "SN — Registered Nurse" },
  { key: "freqPhysicalTherapy", label: "PT — Physical Therapist" },
  { key: "freqOccupationalTherapy", label: "OT — Occupational Therapist" },
  { key: "freqSpeechTherapy", label: "ST — Speech Therapist" },
  { key: "freqMedicalSocialWorker", label: "MSW — Medical Social Worker" },
  { key: "freqHomeHealthAide", label: "HHA — Home Health Aide" },
];

export const ORDER_MODES = [
  { value: "verbal", label: "Verbal Order" },
  { value: "non_verbal", label: "Non-Verbal Order" },
];

/** Create a client-side id that fits the backend max length of 64. */
export const newOrderBlockId = () =>
  `ob_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
